<script setup lang="ts">
import { getFieldNames } from "./getNames";
import CaseSearchFieldDescription from "./CaseSearchFieldDescription.vue";

import type { BooleanFilterField } from "@/models/Column";

withDefaults(defineProps<{
  config: BooleanFilterField;
  displayName: string;
  fieldPath: string;
  isCollection: boolean;
  lastSearch?: { value?: "true" | "false" };
}>(), {  })

const { fieldTypeName, fieldValueName, fieldIsCollectionName, fieldHelpTextId } = getFieldNames(__props.fieldPath, __props.config);
</script>
<template>
  <div class="max-w-md tw-relative tw-shrink-0 tw-space-y-1">
    <label
      tabindex="0"
      :for="fieldValueName"
      class="tw-block tw-text-sm tw-font-medium tw-underline-offset-2 tw-outline-none focus:tw-underline"
    >
      {{ displayName }}
    </label>
    <CaseSearchFieldDescription v-if="config.helpText" :id="fieldHelpTextId" :help-text="config.helpText" />
    <input type="hidden" :name="fieldTypeName" value="boolean" />
    <input type="hidden" :name="fieldIsCollectionName" :value="isCollection" />
    <select
      :id="fieldValueName"
      :name="fieldValueName"
      :aria-label="config.description"
      :aria-describedby="config.helpText ? fieldHelpTextId : undefined"
      class="tw-w-full tw-rounded-md tw-border tw-border-gray-500 tw-bg-white tw-p-2"
      :value="lastSearch?.value ?? (config.defaultValue == null ? '' : config.defaultValue)"
    >
      <option></option>
      <option v-for="option in config.options" :key="option.label" :value="option.value">
        {{ option.label ?? option.value }}
      </option>
    </select>
  </div>
</template>
